import type { TileImage, Variation } from '@shared/types/types.ts';

const EMPTY_IMAGE: TileImage = { id: '', alt: '', fallback: '', jpeg: '', webp: '' };

export type LayoutImageIntents = {
    cutoutActive: boolean;
    multipleImagesActive: boolean;
};

/**
 *
 *
 *
 *
 *
 */
export function getStatusQuoImages(rawImages: TileImage[]): { images: TileImage[]; primaryImage: TileImage } {
    const images = rawImages.slice(0, 3);
    const first = images[0];
    return { images, primaryImage: first !== undefined ? first : EMPTY_IMAGE };
}

export function getLayoutImages(
    variation: Variation,
    intents?: LayoutImageIntents,
): { images: TileImage[]; primaryImage: TileImage } {
    const rawImages = variation.images;

    if (!intents?.cutoutActive || !variation.cutout?.image?.id) {
        return getStatusQuoImages(rawImages);
    }

    const cutoutImage = variation.cutout.image;

    if (!intents.multipleImagesActive) {
        return { images: getStatusQuoImages(rawImages).images, primaryImage: cutoutImage };
    }

    const images = [cutoutImage, ...rawImages.filter((img) => img.id !== cutoutImage.id)].slice(0, 3);
    return { images, primaryImage: cutoutImage };
}

/**
 *
 *
 *
 *
 */
export function shouldDimCutoutImage(variation: Variation, intents?: LayoutImageIntents): boolean {
    return !!intents?.cutoutActive && !!variation.cutout?.hasWhiteBackground;
}
